import { compact, get, keyBy, getOr, filter, compose, reject, map, matchesProperty, find } from 'lodash/fp';
import { createSelector } from 'reselect';
import { GeneralApplicationScopeType as ScopeType } from '@mews-commander/data-access';
import { Classification } from '@mews-commander/enums';
import { createReducer } from '@mews/framework';
import { getOrEmptyObject, getStringProp } from '@mews/fp';
import { createRelatedEntitySelector, createForeignKeyMatcher } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';

export const NAME = 'scopes';
export const keyByEnterpriseId = keyBy('enterpriseId');

const initialState = {};
export const SCOPES_LOADED = prefix('SCOPES_LOADED');

export const rejectPersonalScopes = reject({ type: ScopeType.Personal });

export const scopesReducer = createReducer(initialState, {
    [SCOPES_LOADED]: (state: $TSFixMe, scopes: $TSFixMe) => {
        const nonPersonalScopes = rejectPersonalScopes(scopes);

        return keyByEnterpriseId(nonPersonalScopes);
    },
});

export const getScopes = createSelector(moduleSelector, (module) => module[NAME]);

export const getScopesProfileIds = createSelector(getScopes, map('profileId'));
export const getScopesEnterpriseIds = createSelector(getScopes, compose(compact, map('enterpriseId')));

export const getScopesScopeIds = createSelector(getScopes, map('id'));

export const getPlatformScope = createSelector(getScopes, (scopes) => find({ type: ScopeType.Platform }, scopes));

export const hasPlatformScopeWithAccessAllEnterprises = createSelector(getPlatformScope, (platformScope) =>
    platformScope ? (platformScope as $TSFixMe).privileges.accessAllEnterprises : false
);

export const getProfileIdFromProps = getStringProp('profileId');
export const profileIdForeignKey = createForeignKeyMatcher('profileId', getProfileIdFromProps);
export const getScopeByProfileId = createRelatedEntitySelector(getScopes, profileIdForeignKey);

export const getAllScopesWithPrivilege = (privilegeName: $TSFixMe) =>
    createSelector(getScopes, filter(get(['privileges', privilegeName])));

export const getScopePrivileges = createSelector(getScopeByProfileId, getOr({}, 'privileges'));

export const getScopeOptions = createSelector(getScopeByProfileId, getOr({}, 'options'));

export const getProfileScopeId = createSelector(getScopeByProfileId, get('id'));

const getProfileId = get('profileId');

export const getScopeProfileId = createSelector(getScopeByProfileId, getProfileId);

export const getScopeAssignedLearningPath = createSelector(getScopeByProfileId, get('assignedLearningPath'));

export const getScopeEnterpriseId = createSelector(getScopeByProfileId, get('enterpriseId'));

export const hasPlatformScope = createSelector(getScopeByProfileId, matchesProperty('type', ScopeType.Platform));

export const hasPlatformAdminScope = createSelector(getPlatformScope, (platformScope) =>
    platformScope ? (platformScope as $TSFixMe).privileges.admin : false
);

export const canPlatformExtendEHW = createSelector(getPlatformScope, (platformScope) =>
    platformScope ? (platformScope as $TSFixMe).privileges.extendEHW : false
);

export const getPlatformScopeProfileId = createSelector(
    getPlatformScope,
    (platformScope) => (platformScope as $TSFixMe)?.profileId
);

export const getScopeByEnterpriseId = createSelector(getStringProp('enterpriseId'), getScopes, getOrEmptyObject);

export const getEnterpriseProfileId = compose(getProfileId, getScopeByEnterpriseId);

export const privilegesToClassificationMapper = ({ admin }: $TSFixMe = {}) =>
    admin ? Classification.Administrator : Classification.Other;
